import { get } from "lodash-es";
import axios from "axios";

export default {
  methods: {
    async getNombreCliente(clienteId) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetClienteSimpleById",
        parameters: [{ name: "id_cliente", value: clienteId }],
      });
      if (resp.data.ok) {
        this.nombreCliente = get(
          resp,
          "data.result[0][0].nombre_web",
          "no hay nombre",
        );
      }
      return resp.data;
    },
  },
  data: () => ({
    nombreCliente: "",
  }),
};
